import { getMasterGlobalTypeList } from 'services/axios/config'
import { getCandidateList } from 'services/axios/emp'

export const actions = {
  GET_CANDIDATE_LIST: 'GET_CANDIDATE_LIST',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
  HANDLE_STATUS: 'HANDLE_STATUS',
  HANDLE_ROUND_STEP: 'HANDLE_ROUND_STEP',
  HANDLE_FILTER_SKILL: 'HANDLE_FILTER_SKILL',
  HANDLE_FILTER_SKILL_LEVEL: 'HANDLE_FILTER_SKILL_LEVEL',
  HANDLE_GRADE: 'HANDLE_GRADE',
  GET_FEEDBACK: 'GET_FEEDBACK',
  GET_SKILLS: 'GET_SKILLS',
}

// export const getCandidates = ({ skip, limit, status, filterSkill, filterSkillLevel, grade }) => { old code
export const getCandidates = ({ skip, limit, status, step, round }) => {
  return async (dispatch) => {
    // const response = await getCandidateList({ old code
    //   skip,
    //   limit,
    //   status,
    //   filterSkill,
    //   filterSkillLevel,
    //   grade,
    // })
    const response = await getCandidateList({
      skip,
      limit,
      status,
      step,
      round,
    })

    dispatch({
      type: actions.GET_CANDIDATE_LIST,
      payload: {
        candidateList: response?.data?.data?.CandidateList,
        totalCount: response?.data?.data?.totalCount,
      },
    })
  }
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}
export const handleStatus = (status) => {
  return {
    type: 'HANDLE_STATUS',
    payload: status,
  }
}
export const handleStep = (step) => {
  return {
    type: 'HANDLE_ROUND_STEP',
    payload: step,
  }
}
export const handleSkill = (skill) => {
  return {
    type: 'HANDLE_FILTER_SKILL',
    payload: skill,
  }
}
export const handleSkillLevel = (skillLevel) => {
  return {
    type: 'HANDLE_FILTER_SKILL_LEVEL',
    payload: skillLevel,
  }
}
export const handleGrade = (grade) => {
  return {
    type: 'HANDLE_GRADE',
    payload: grade,
  }
}

export const getFeedBackStatus = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('feedback')
    if (response?.status === 200 && response?.data?.data?.length > 0) {
      const feedback = response?.data?.data
      dispatch({
        type: actions.GET_FEEDBACK,
        payload: feedback,
      })
    }
  }
}

export const getSkills = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('skills')
    if (response?.status === 200 && response?.data?.data?.length > 0) {
      const skills = response?.data?.data
      dispatch({
        type: actions.GET_SKILLS,
        payload: skills,
      })
    }
  }
}
